import {
  PUBLIC_ROOT,
  PRIVATE_ROOT,
  DATABASE_MAINTENANCE,
} from 'portal-modules/common/constants/urls'
import asyncComponent from 'portal-modules/common/components/asyncComponent'

const routes = [
  {
    path: PUBLIC_ROOT,
    component: asyncComponent({
      loader: () =>
        import(/* webpackChunkName: "auth" */ 'portal-modules/auth/pages'),
    }),
  },
  {
    restricted: true,
    path: PRIVATE_ROOT,
    component: asyncComponent({
      loader: () => import(/* webpackChunkName: "app" */ './App'),
    }),
  },
  {
    path: '/unsubscribe',
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackChunkName: "unsubscribe" */ 'portal-modules/settings/pages/Unsubscribe'
        ),
    }),
  },
  {
    path: DATABASE_MAINTENANCE,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackChunkName: "database-down" */ 'portal-modules/common/pages/DownForMaintenance'
        ),
    }),
  },
  {
    restricted: true,
    path: '*',
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackChunkName: "page-not-found" */ 'portal-modules/common/pages/PageNotFound'
        ),
    }),
  },
]

export default routes
